import React, { useMemo, useState } from 'react'
import styles from './style.module.scss'

export const HandbookTable = ({ columns, rows = [], filter = false, rowId, highlightId }) => {
  const [query, setQuery] = useState('')
  const filtered = useMemo(() => {
    if (!query) {
      return rows
    }
    const needle = query.toLowerCase()
    return rows.filter(row => columns.some(column => String(row[column.key] ?? '').toLowerCase().includes(needle)))
  }, [columns, query, rows])

  const showFilter = filter || rows.length > 8
  const countLabel = filtered.length === rows.length ? `${rows.length} rows` : `${filtered.length} of ${rows.length}`

  return (
    <div className={styles.tablePanel}>
      <div className={styles.tableToolbar}>
        <span className={styles.tableCount}>{countLabel}</span>
        {showFilter && (
          <input className={styles.filterInput} type='search' placeholder='Filter rows' value={query} onChange={event => setQuery(event.target.value)} />
        )}
      </div>
      <div className={`${styles.tableWrap} ${rows.length > 20 ? styles.tableWrapTall : ''}`}>
        <table className={styles.table}>
          <thead>
            <tr>
              {columns.map(column => (
                <th key={column.key}>{column.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={columns.length}>No matching rows.</td>
              </tr>
            ) : (
              filtered.map((row, index) => {
                const id = rowId ? rowId(row) : undefined
                return (
                  <tr key={row.id ?? id ?? index} id={id} className={highlightId && id === highlightId ? styles.rowHighlight : undefined}>
                    {columns.map(column => (
                      <td key={column.key}>{column.render ? column.render(row[column.key], row) : row[column.key]}</td>
                    ))}
                  </tr>
                )
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
